import ReactTable from 'react-table';
import PropTypes from 'prop-types';
import React from 'react';
import withToggle from '../../../common/hoc/withToggle';
import { username } from '../helpers';

const CustomerShops = ({ shops }) => (
  <ReactTable
    data={shops}
    showPagination={false}
    minRows={0}
    resizable={false}
    className="ReactTable u-fontsize-extrasmall"
    columns={[
      {
        Header: 'Name',
        accessor: 'name',
      },
      {
        Header: 'Appts count',
        id: 'appt-count',
        accessor: shop => shop.appointments.length,
      },
    ]}
    SubComponent={row => (
      <ReactTable
        data={row.original.appointments}
        showPagination={false}
        minRows={0}
        resizable={false}
        className="ReactTable ReactTable--no-td-overflow"
        columns={[
          {
            id: 'appt-info',
            accessor: d => d,
          },
        ]}
      />
    )}
  />
);

const CustomerDetails = ({ customer, detailsToggle, detailsIsOn, showDetails }) => (
  <div>
    <p><strong>First Name</strong>: {customer.firstName}</p>
    <p><strong>Last Name</strong>: {customer.lastName}</p>
    <p><strong>Email</strong>: {customer.email}</p>
    <p><strong>Phone</strong>: {customer.phone}</p>
    <p><strong>Username</strong>: {username(customer)}</p>
    <button className="c-btn c-btn--small u-mt-" display-if={showDetails} onClick={detailsToggle}>
      Shop details
    </button>
    <div display-if={showDetails && detailsIsOn} className="u-mt-">
      <CustomerShops shops={customer.shops} />
    </div>
  </div>
);

CustomerDetails.propTypes = {
  customer: PropTypes.object,
  detailsToggle: PropTypes.func.isRequired,
  detailsIsOn: PropTypes.bool,
  showDetails: PropTypes.bool,
};

CustomerDetails.defaultProps = {
  customer: {},
  detailsIsOn: false,
  showDetails: true,
};

export default withToggle('details')(CustomerDetails);
